import { Record } from "immutable";
import avatarInitials from "lib/avatar-initials";

const defaults = {
    _id: undefined,
    email: undefined,
    name: undefined,
};

export class UserRecord extends Record(defaults) {
    declare id: string;
    declare name: string;
    declare email: string;

    get initials() {
        return avatarInitials(this.name.toString());
    }
}

export default UserRecord;
